import { apiClient } from '@/lib/api/client';
export const passengersApi = {
    async getPassengers(query) {
        const { data } = await apiClient.get('/api/v1/passengers', { params: query });
        return data;
    },
    async getPassenger(id) {
        const { data } = await apiClient.get(`/api/v1/passengers/${id}`);
        return data;
    },
    /** GET /api/v1/passengers?groupId=xxx — fetches all pages (backend max=100) */
    async listByGroup(groupId) {
        const PAGE_SIZE = 100;
        let page = 1;
        let all = [];
        while (true) {
            const { data } = await apiClient.get('/api/v1/passengers', {
                params: { groupId, pageSize: PAGE_SIZE, page },
                headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
            });
            const items = data.data ?? [];
            all = all.concat(items);
            const meta = data.meta;
            const total = meta?.total ?? items.length;
            if (all.length >= total || items.length < PAGE_SIZE)
                break;
            page++;
        }
        return all;
    },
    async createPassenger(dto) {
        const { data } = await apiClient.post('/api/v1/passengers', dto);
        return data;
    },
    async updatePassenger(id, dto) {
        const { data } = await apiClient.patch(`/api/v1/passengers/${id}`, dto);
        return data;
    },
    async deletePassenger(id) {
        await apiClient.delete(`/api/v1/passengers/${id}`);
    },
    async bulkCreate(groupId, passengers) {
        const { data } = await apiClient.post('/api/v1/passengers/bulk', {
            groupId,
            passengers,
        });
        return data;
    },
    async bulkDelete(groupId, ids) {
        const { data } = await apiClient.delete('/api/v1/passengers/bulk-delete', {
            data: { groupId, ids },
        });
        return data;
    },
    async updateStatus(id, status) {
        const { data } = await apiClient.patch(`/api/v1/passengers/${id}/status`, { status });
        return data;
    },
};
//# sourceMappingURL=passengers.js.map